import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useLanguage } from "@/contexts/LanguageContext";

const conversions = {
  colherCha: {
    title: "Colher de Chá",
    capacity: "~5 ml",
    items: [
      { ingrediente: "Água / Leite / Vinagre", g: "5 g", ml: "5 ml", kg: "0.005 kg", L: "0.005 L" },
      { ingrediente: "Óleo / Azeite", g: "4 g", ml: "5 ml", kg: "0.004 kg", L: "0.005 L" },
      { ingrediente: "Açúcar", g: "3.5 g", ml: "5 ml", kg: "0.0035 kg", L: "0.005 L" },
      { ingrediente: "Sal fino", g: "5 g", ml: "5 ml", kg: "0.005 kg", L: "0.005 L" },
      { ingrediente: "Farinha de trigo", g: "2.5 g", ml: "5 ml", kg: "0.0025 kg", L: "0.005 L" },
      { ingrediente: "Fermento em pó", g: "3 g", ml: "5 ml", kg: "0.003 kg", L: "0.005 L" },
      { ingrediente: "Manteiga derretida", g: "4 g", ml: "5 ml", kg: "0.004 kg", L: "0.005 L" },
      { ingrediente: "Cacau em pó", g: "2 g", ml: "5 ml", kg: "0.002 kg", L: "0.005 L" },
      { ingrediente: "Canela em pó", g: "2.5 g", ml: "5 ml", kg: "0.0025 kg", L: "0.005 L" },
      { ingrediente: "Mel", g: "7 g", ml: "5 ml", kg: "0.007 kg", L: "0.005 L" },
    ]
  },
  colherSopa: {
    title: "Colher de Sopa",
    capacity: "~15 ml",
    items: [
      { ingrediente: "Água / Leite / Vinagre", g: "15 g", ml: "15 ml", kg: "0.015 kg", L: "0.015 L" },
      { ingrediente: "Óleo / Azeite", g: "12 g", ml: "15 ml", kg: "0.012 kg", L: "0.015 L" },
      { ingrediente: "Açúcar", g: "12 g", ml: "15 ml", kg: "0.012 kg", L: "0.015 L" },
      { ingrediente: "Sal fino", g: "15 g", ml: "15 ml", kg: "0.015 kg", L: "0.015 L" },
      { ingrediente: "Farinha de trigo", g: "7.5 g", ml: "15 ml", kg: "0.0075 kg", L: "0.015 L" },
      { ingrediente: "Fermento em pó", g: "10 g", ml: "15 ml", kg: "0.010 kg", L: "0.015 L" },
      { ingrediente: "Manteiga derretida", g: "12 g", ml: "15 ml", kg: "0.012 kg", L: "0.015 L" },
      { ingrediente: "Cacau em pó", g: "6 g", ml: "15 ml", kg: "0.006 kg", L: "0.015 L" },
      { ingrediente: "Leite condensado", g: "20 g", ml: "15 ml", kg: "0.020 kg", L: "0.015 L" },
      { ingrediente: "Mel", g: "21 g", ml: "15 ml", kg: "0.021 kg", L: "0.015 L" },
      { ingrediente: "Amido de milho", g: "8 g", ml: "15 ml", kg: "0.008 kg", L: "0.015 L" },
      { ingrediente: "Creme de leite", g: "15 g", ml: "15 ml", kg: "0.015 kg", L: "0.015 L" },
    ]
  },
  xicara: {
    title: "Xícara (chá)",
    capacity: "~240 ml",
    items: [
      { ingrediente: "Água / Leite / Vinagre", g: "240 g", ml: "240 ml", kg: "0.240 kg", L: "0.240 L" },
      { ingrediente: "Óleo / Azeite", g: "200 g", ml: "240 ml", kg: "0.200 kg", L: "0.240 L" },
      { ingrediente: "Açúcar", g: "200 g", ml: "240 ml", kg: "0.200 kg", L: "0.240 L" },
      { ingrediente: "Açúcar de confeiteiro", g: "140 g", ml: "240 ml", kg: "0.140 kg", L: "0.240 L" },
      { ingrediente: "Farinha de trigo", g: "120 g", ml: "240 ml", kg: "0.120 kg", L: "0.240 L" },
      { ingrediente: "Farinha de rosca", g: "80 g", ml: "240 ml", kg: "0.080 kg", L: "0.240 L" },
      { ingrediente: "Manteiga", g: "200 g", ml: "240 ml", kg: "0.200 kg", L: "0.240 L" },
      { ingrediente: "Cacau em pó", g: "90 g", ml: "240 ml", kg: "0.090 kg", L: "0.240 L" },
      { ingrediente: "Arroz cru", g: "185 g", ml: "240 ml", kg: "0.185 kg", L: "0.240 L" },
      { ingrediente: "Aveia em flocos", g: "80 g", ml: "240 ml", kg: "0.080 kg", L: "0.240 L" },
      { ingrediente: "Leite em pó", g: "130 g", ml: "240 ml", kg: "0.130 kg", L: "0.240 L" },
      { ingrediente: "Coco ralado", g: "80 g", ml: "240 ml", kg: "0.080 kg", L: "0.240 L" },
      { ingrediente: "Polvilho", g: "150 g", ml: "240 ml", kg: "0.150 kg", L: "0.240 L" },
      { ingrediente: "Mel", g: "340 g", ml: "240 ml", kg: "0.340 kg", L: "0.240 L" },
      { ingrediente: "Chocolate em gotas", g: "170 g", ml: "240 ml", kg: "0.170 kg", L: "0.240 L" },
    ]
  }
};

const quickRef = [
  { medida: "1 colher de café", ml: "2 ml" },
  { medida: "1 colher de chá", ml: "5 ml" },
  { medida: "1 colher de sobremesa", ml: "10 ml" },
  { medida: "1 colher de sopa", ml: "15 ml" },
  { medida: "1 xícara (chá)", ml: "240 ml" },
  { medida: "1 xícara (café)", ml: "60 ml" },
  { medida: "1 copo americano", ml: "200 ml" },
  { medida: "1 litro", ml: "1000 ml" },
];

const weightRef = [
  { de: "1 g", para: "0.001 kg" },
  { de: "10 g", para: "0.010 kg" },
  { de: "100 g", para: "0.100 kg" },
  { de: "250 g", para: "0.250 kg" },
  { de: "500 g", para: "0.500 kg" },
  { de: "1000 g", para: "1.000 kg" },
  { de: "1 ml", para: "0.001 L" },
  { de: "100 ml", para: "0.100 L" },
  { de: "250 ml", para: "0.250 L" },
  { de: "500 ml", para: "0.500 L" },
  { de: "1000 ml", para: "1.000 L" },
];

function ConversionTable({ data }) {
  return (
    <div className="border border-zinc-200 rounded-sm overflow-hidden">
      <div className="overflow-x-auto"><Table>
        <TableHeader>
          <TableRow className="bg-zinc-50">
            <TableHead className="text-xs uppercase tracking-wider font-semibold text-zinc-500">Ingrediente</TableHead>
            <TableHead className="text-xs uppercase tracking-wider font-semibold text-zinc-500 text-center">Gramas</TableHead>
            <TableHead className="text-xs uppercase tracking-wider font-semibold text-zinc-500 text-center">Mililitros</TableHead>
            <TableHead className="text-xs uppercase tracking-wider font-semibold text-zinc-500 text-center">Quilos</TableHead>
            <TableHead className="text-xs uppercase tracking-wider font-semibold text-zinc-500 text-center">Litros</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.items.map((item, i) => (
            <TableRow key={item.ingrediente} className={i % 2 === 0 ? "" : "bg-zinc-50/50"}>
              <TableCell className="font-medium text-zinc-900">{item.ingrediente}</TableCell>
              <TableCell className="text-center font-mono text-zinc-700">{item.g}</TableCell>
              <TableCell className="text-center font-mono text-zinc-700">{item.ml}</TableCell>
              <TableCell className="text-center font-mono text-zinc-700">{item.kg}</TableCell>
              <TableCell className="text-center font-mono text-zinc-700">{item.L}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table></div>
    </div>
  );
}

export default function MeasureConversions() {
  const { t } = useLanguage();
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl md:text-2xl font-bold tracking-tight text-zinc-950">{t("mc_title")}</h2>
        <p className="text-sm text-zinc-500 mt-1">{t("mc_subtitle")}</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card className="border-zinc-200 shadow-sm rounded-sm">
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-semibold text-zinc-900">Medidas Caseiras em Volume</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="border border-zinc-200 rounded-sm overflow-hidden">
              <div className="overflow-x-auto"><Table>
                <TableHeader>
                  <TableRow className="bg-zinc-50">
                    <TableHead className="text-xs uppercase tracking-wider font-semibold text-zinc-500">Medida</TableHead>
                    <TableHead className="text-xs uppercase tracking-wider font-semibold text-zinc-500 text-center">Volume</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {quickRef.map((item, i) => (
                    <TableRow key={item.medida} className={i % 2 === 0 ? "" : "bg-zinc-50/50"}>
                      <TableCell className="font-medium text-zinc-900">{item.medida}</TableCell>
                      <TableCell className="text-center font-mono text-zinc-700 font-semibold">{item.ml}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table></div>
            </div>
          </CardContent>
        </Card>

        <Card className="border-zinc-200 shadow-sm rounded-sm">
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-semibold text-zinc-900">Conversão de Peso e Volume</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="border border-zinc-200 rounded-sm overflow-hidden">
              <div className="overflow-x-auto"><Table>
                <TableHeader>
                  <TableRow className="bg-zinc-50">
                    <TableHead className="text-xs uppercase tracking-wider font-semibold text-zinc-500">De</TableHead>
                    <TableHead className="text-xs uppercase tracking-wider font-semibold text-zinc-500 text-center">Para</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {weightRef.map((item, i) => (
                    <TableRow key={item.de} className={i % 2 === 0 ? "" : "bg-zinc-50/50"}>
                      <TableCell className="font-medium font-mono text-zinc-900">{item.de}</TableCell>
                      <TableCell className="text-center font-mono text-zinc-700 font-semibold">{item.para}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table></div>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card className="border-zinc-200 shadow-sm rounded-sm" data-testid="measure-conversions-detail">
        <CardHeader>
          <CardTitle className="text-lg font-semibold tracking-tight text-zinc-900">
            Conversão por Ingrediente
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs defaultValue="colherCha" className="w-full">
            <TabsList className="grid w-full grid-cols-3 mb-4">
              <TabsTrigger value="colherCha" data-testid="tab-colher-cha">
                Colher de Chá
              </TabsTrigger>
              <TabsTrigger value="colherSopa" data-testid="tab-colher-sopa">
                Colher de Sopa
              </TabsTrigger>
              <TabsTrigger value="xicara" data-testid="tab-xicara">
                Xícara
              </TabsTrigger>
            </TabsList>

            {Object.entries(conversions).map(([key, data]) => (
              <TabsContent key={key} value={key}>
                <div className="mb-3">
                  <p className="text-sm text-zinc-600">
                    <span className="font-semibold">1 {data.title}</span> = <span className="font-mono">{data.capacity}</span>
                  </p>
                </div>
                <ConversionTable data={data} />
              </TabsContent>
            ))}
          </Tabs>
        </CardContent>
      </Card>

      <div className="text-center py-4">
        <p className="text-xs text-zinc-400">
          Valores aproximados. A gramatura pode variar de acordo com o ingrediente e forma de medição.
        </p>
      </div>
    </div>
  );
}
